import { cloudFetch } from './http.js'

export function safeDownloadFilename(value, fallback = 'download') {
  const normalized = String(value || '').trim().replace(/[\\/:*?"<>|\u0000-\u001f]/g, '_')
  return normalized.slice(0, 180) || fallback
}

export async function downloadCloudFile(path, { filename = 'download', signal } = {}) {
  const blob = await cloudFetch(path, { method: 'GET', parseAs: 'blob', signal, timeoutMs: 120_000 })
  const objectUrl = URL.createObjectURL(blob)
  try {
    const anchor = document.createElement('a')
    anchor.href = objectUrl
    anchor.download = safeDownloadFilename(filename)
    anchor.rel = 'noopener'
    document.body.append(anchor)
    anchor.click()
    anchor.remove()
  } finally {
    URL.revokeObjectURL(objectUrl)
  }
}
